import { DragEventHandler, ReactNode, LegacyRef, forwardRef } from 'react';
import cx from 'classnames/bind';

import styles from './Message.module.scss';

interface MessageProps {
  children: string | ReactNode;
  user?: 'buyer' | 'manager';
  className: string;
  isDraggable?: boolean;
  onDragStart?: DragEventHandler<HTMLDivElement>;
  id?: number;
}

const cn = cx.bind(styles);

const Message = forwardRef(
  (
    {
      children,
      user,
      className,
      isDraggable = false,
      onDragStart,
      id,
    }: MessageProps,
    ref?: LegacyRef<HTMLDivElement>,
  ) => (
    <div
      ref={ref}
      id={String(id)}
      draggable={isDraggable}
      onDragStart={onDragStart}
      className={cn('container', className)}
    >
      {user && (
        <span className={cn('user')}>
          {user === 'manager' ? 'Консультант JTI' : 'Покупатель'}
        </span>
      )}
      <p className={cn('message')}>{children}</p>
    </div>
  ),
);

export default Message;
